import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { Message } from '../../models/Message';
import { StudentEventItem } from '../../models/SaidEvent';
import { AppService } from '../../services/app.service';
import { MessageService } from '../../services/message.service';

const state: {
    messages?: {
        explanations: string,
        supervisedExplanations: string,
        unavailable: string
    }
} = {};

export class Helpers {
    static canAddProgram(program: StudentEventItem): boolean {
        return !program.GroupIsFull;
    }

    static canRemoveProgram(program: StudentEventItem): boolean {
        return !Helpers.validateDate(program.RegistrationOpenDate, program.RegistrationCloseDate);//program.Application_statuss_code == 866560002 //&& program.CanWithdraw; //??? jāmaina nosacījumi[disabled]="validateDate(c.RegistrationOpenDate, c.RegistrationCloseDate)"
    }

    static validateDate(startDate: Date, endDate: Date) {
        //return (formatDate(new Date(startDate), "dd.MM.yyyy", "lv-LV") > formatDate(new Date(), "dd.MM.yyyy", "lv-LV")) || (formatDate(new Date(endDate), "dd.MM.yyyy", "lv-LV") < formatDate(new Date(), "dd.MM.yyyy", "lv-LV"));
        return (this.removeTime(new Date(startDate)) > this.removeTime(new Date())) || (this.removeTime(new Date(endDate)) < this.removeTime(new Date()));
    }
    
    static removeTime(dt: Date) {
        let newDt = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate());
        return newDt;
    }

    static getMessages(app: AppService, messageService: MessageService) {
        if (state.messages) return of(state.messages);

        return app.addLoading(messageService.getText([
            'SAID_EVENTS_EXPLANATIONS',
            'SAID_EVENTS_SUPERVISED_EXPLANATIONS',
            'SAID_EVENTS_NOAVAIL_MESSAGE'
        ])).pipe(map(data => {
            const items = {
                explanations: data.find(t => t.Code == 'SAID_EVENTS_EXPLANATIONS')?.Text,
                supervisedExplanations: data.find(t => t.Code == 'SAID_EVENTS_SUPERVISED_EXPLANATIONS')?.Text,
                unavailable: data.find(t => t.Code == 'SAID_EVENTS_NOAVAIL_MESSAGE')?.Text
            };

            state.messages = items;

            return items;
        }));
    }
}
